<template>
    <div>
        <section class="internal-page-banner-main col-12">
            <div class="container">
                <div class="row">
                    <div class="page-title">
                        <h1> Manager Tool Box </h1>
                    </div>
                </div>
            </div>
        </section>
        <div class="internal-page-main-section faq-section-main forum-main col-12">
            <div class="container">
                <div class="MainForum">
                    <div class="ForumTop">
                        <div class="ForumSearch">
                            <div class="input-group">
                                <input v-on:keyup.enter="searchCall()" type="text" aria-describedby="button-addon4" class="form-control bg-none border-0 forum-input" id="searchManagerToolBox" placeholder="Search" v-model="searchManagerToolBox" name="searchManagerToolBox" />
                                <div class="input-group-prepend border-0">
                                    <button v-on:click.prevent="searchCall()" id="button-addon4" type="button" class="btn btn-link text-info"><i class="fa fa-search"></i></button> 
                                    <button v-on:click.prevent="clearSearch()" id="button-clear" type="button" class="btn btn-link text-info clear-search"><i class="fa fa-times"></i></button>
                                </div> 
                                <div class="col-md-4">
                                    <v-select class="input-field-si" v-model="sortManagerToolBox" 
                                        name="sortManagerToolBox" 
                                        placeholder="Select field for sorting"
                                        label="text"
                                        :options="sortManagerToolBoxArr"
                                        :clearable=false>
                                    </v-select>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="ForumPage">
                        <div class="ForumListing">
                            <div v-if="(managerToolBoxArr && (managerToolBoxArr.folderData && managerToolBoxArr.folderData.length > 0))" class="internal-listing-container">
                                <template v-for="(managerToolBox, index) in managerToolBoxArr.folderData">
                                    <div v-bind:key="index" class="single-listing">
                                        <div class="upload-doc-img">
                                            <template>
                                                <img src="/static/images/folder-icon.png">
                                            </template>
                                        </div>
                                        <div class="single-listing-text" v-on:click.prevent="getDocuments(index, managerToolBox)">
                                            <span v-b-tooltip.hover :title="managerToolBox.title">{{stringTrim(managerToolBox.title,60)}}</span>
                                        </div>
                                        <div class="download">
                                            <a v-on:click.prevent="downLoadfiles(managerToolBox)" class="downloadnow">Download Now!</a>
                                        </div>
                                        <div class="listing-user-info1">
                                            <div class="user-details">
                                                <div class="listing-user">{{managerToolBox.updated_name}}</div>
                                                <div class="listing-block-info">
                                                    <div class="listing-date">{{managerToolBox.updated_date}}</div>
                                                    <div class="listing-time">{{managerToolBox.updated_time}}</div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </template>
                            </div>
                            <div v-else class="internal-listing-container" style="text-align: center;">
                                Data Not Available
                            </div>
                            <div v-if="managerToolBoxArr.total_rows >= managerToolBoxArr.per_page">
                                <b-pagination align="center" prev-text="‹ Previous" next-text="Next ›" :total-rows="managerToolBoxArr.total_rows" v-model="currentPage" :per-page="managerToolBoxArr.per_page"></b-pagination>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Vue from "vue";
    import vSelect from 'vue-select';
    import SessioMixin from '../mixins/sessionmixin';
    import { Button } from 'bootstrap-vue/es/components';
    import {HTTP} from '../http-common';

    var self;
    export default {
        name: 'ManagerToolBox',
        mixins: [SessioMixin],
        components: {
            'v-select': vSelect,
        },
        data() {
            return {
                managerToolBoxArr: [],
                currentPage: 1,
                searchManagerToolBox: '',
                sortManagerToolBox: {text: 'Newest First', value: 'desc'},
                sortManagerToolBoxArr: [
                    {
                        text: 'Newest First',
                        value: 'desc'
                    },
                    {
                        text: 'Oldest First',
                        value: 'asc'
                    }
                ],
            }
        },
        watch: {
            currentPage: function() {
                self.loadManagetToolBox();
            },
            sortManagerToolBox: function() {
                self.loadManagetToolBox();
            },
        },
        beforeMount: function () {
            self = this;
            self.checkLogin();
        },
        mounted: function () {
            $("#alertError").hide();
            self.MenuClose();
            self.loadManagetToolBox();
        },
        methods: {
            searchCall() {
                self.currentPage = 1;
                self.loadManagetToolBox();
            },
            clearSearch() {
                self.currentPage = 1;
                self.searchManagerToolBox = '';
                self.loadManagetToolBox();
            },
            loadManagetToolBox: function () {
                var self = this;
                var config = {
                    headers: {Authorization: "Bearer " + localStorage.getItem("api_token")},
                    params: {
                        'path': 'main',
                        'page': self.currentPage,
                        'filter': self.searchManagerToolBox,
                        'sort': self.sortManagerToolBox.value,
                    }
                };
                self.showLoader();
                HTTP.get("/folder/list", config)
                        .then(function (response) {
                            if (response.data.code == '200') {
                                self.managerToolBoxArr = response.data.content;
                                if (response.data.content.length <= 0) {
                                    self.currentPage = 1;
                                }
                            }
                            self.hideLoader();
                        })
                        .catch(function (err) {
                            self.hideLoader();
                            if (err.response.status == 0) {
                                self.error = "Remote server can not be reachable";
                            } else {
                                //redirect to login page if user not authenticated
                                if (err.response.status == 401) {
                                    //clear previous data
                                    localStorage.removeItem("user_obj");
                                    localStorage.removeItem("api_token");
                                    localStorage.removeItem("profile_image");
                                    self.$router.push("/login");
                                    //EventBus.$emit("logged-in", true, "", "");
                                }
                                self.error = err.response.data.message;
                            }
                        });
            },
            downLoadfiles: function (data) {
                var self = this;
                var config = {
                    headers: {Authorization: "Bearer " + localStorage.getItem("api_token")},
                    params: {
                        'id': data.id,
                        'page': self.currentPage,
                        'filter': self.searchManagerToolBox,
                        'sort': self.sortManagerToolBox.value,
                    }
                };
                self.showLoader();
                HTTP.get("/download/zip/file", config)
                        .then(function (response) {
                            if (response.data.code == '200') {
                                console.log(response.data.content)
                                location.href = response.data.content
                                
                                // self.managerToolBoxArr = response.data.content;
                                // if (response.data.content.length <= 0) {
                                //     // self.currentPage = 1;
                                // }
                            }
                            self.hideLoader();
                        })
                        .catch(function (err) {
                            self.hideLoader();
                            if (err.response.status == 0) {
                                self.error = "Remote server can not be reachable";
                            } else {
                                //redirect to login page if user not authenticated
                                if (err.response.status == 401) {
                                    //clear previous data
                                    localStorage.removeItem("user_obj");
                                    localStorage.removeItem("api_token");
                                    localStorage.removeItem("profile_image");
                                    self.$router.push("/login");
                                    //EventBus.$emit("logged-in", true, "", "");
                                }
                                self.error = err.response.data.message;
                            }
                        });
            },
            getDocuments: function(id, managerToolBox){
                console.log(id);
                console.log(managerToolBox.id);
                self.$router.push('/documentsmanagertoolbox/'+managerToolBox.id);
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/ManagerToolBox.vue